import { z } from "zod";

export const addEventViewsSchema = z.object({
  eventIds: z
    .array(z.string())
    .min(1, "Vous devez sélectionner au moins un événement"),
  viewsCount: z.coerce
    .number()
    .min(1, "Le nombre de vues doit être supérieur à 0"),
});

export type AddEventViewsForm = z.infer<typeof addEventViewsSchema>;
